import React from 'react';
import style from '@src/js/Style';
import Input from '../Form/Input';
import MortgageCost from './MortgageCost';
import ImageRange from '../Form/ImageRange';
import NumberFormatter from '../../NumberFormatter';

export default class MortgageCredit extends MortgageCost {

    renderPart1() {

        return (<>

            {/* credit sum */}
            <div className={ style('flex flex-wrap w-full') }>
                <Input
                    label={ this.state.creditSum.label }
                    name='credit_sum'
                    format='number'
                    suffix={ this.state.currency }
                    min={ this.state.creditSum.min }
                    max={ this.state.creditSum.max }
                    onChange={ (e) => this.changeRangeEvent(e) }
                    value={ this.state.creditSum.value } />
                { this.renderTags(this.state.creditSum.tags, 'credit_sum', this.state.currency) }
            </div>

            {/* term */}
            { this.renderTerm() }
            
            {/* rate */}
            { this.renderRate() }

            {/* payment type */}
            { this.renderPaymentType() }

        </>);
    }

    renderImageRange() {

        return <ImageRange value={ this.state.creditSum.value.toFloat() } items={ this.state.price.images } />;
    }

    changeRangeEvent(e) {

        this.state.creditSum.value = NumberFormatter.parse(e.target.value);
        this.setState({ creditSum: this.state.creditSum });
    }

}